module.exports = __webpack_public_path__ + "img/098-guatemala.60660276.svg";